import { lazy } from 'react';
import { retry } from '../../../config/utils';

const ListOfProfileData = lazy(() => retry(() => import(/* webpackChunkName: "ListOfProfileData" */ ".")));

export default ListOfProfileData;